import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ConsentService } from '@lobos/library';
import { TranslocoService } from '@ngneat/transloco';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-cookie-consent',
  styleUrls: ['./cookie-consent.component.scss'],
  template: '',
})
export class CookieConsentComponent implements OnInit {
  constructor(@Inject(PLATFORM_ID) private platformId: any, private consentService: ConsentService, private transloco: TranslocoService) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const cookieService = this.consentService;
      const logo =
        '<img src="/assets/images/logo_W101.png" alt="Logo" loading="lazy" style="margin-left: -4px; margin-bottom: -5px; height: 35px">';
      const cookie = '🍪';
      const lang = this.transloco.getActiveLang();

      this.transloco
        .load(`shared/${lang}`)
        .pipe(take(1))
        .subscribe(() => {
          const t = (key: string) => this.transloco.translate(`shared.cookie-consent.${key}`);
          const cc = (window as any).initCookieConsent();
          cc.run({
            onAccept: function () {
              if (cc.allowedCategory('analytics')) {
                cookieService.updateConsent(true);
              }
            },
            categories: ['necessary', 'analytics'],
            level: ['necessary', 'analytics'],
            revision: 0,
            data: null,
            rfc_cookie: false,
            consent_date: '2022-10-18T12:24:52.251Z',
            consent_uuid: 'fc39cb7f-cd46-405d-915a-00ea9a5cffe6',
            last_consent_update: '2022-10-18T12:24:54.251Z',
            gui_options: {
              consent_modal: {
                layout: 'bar', // box,cloud,bar
                position: 'bottom', // bottom,middle,top + left,right,center
                transition: 'slide', // zoom,slide
              },
              settings_modal: {
                layout: 'box', // box,bar
                // position: 'left',                // right,left (available only if bar layout selected)
                transition: 'slide', // zoom,slide
              },
            },
            languages: {
              [lang]: {
                consent_modal: {
                  title: cookie + ' ' + t('consent-modal-title') + ' ',
                  description: t('consent-modal-description'),
                  primary_btn: {
                    text: t('accept-all'),
                    role: 'accept_all', // 'accept_selected' or 'accept_all'
                  },
                  secondary_btn: {
                    text: t('reject-all'),
                    role: 'accept_necessary', // 'settings' or 'accept_necessary'
                  },
                },
                settings_modal: {
                  title: logo,
                  save_settings_btn: t('save-settings'),
                  accept_all_btn: t('accept-all'),
                  reject_all_btn: t('reject-all'),
                  close_btn_label: t('close'),
                  cookie_table_headers: [{ col1: 'Name' }, { col2: 'Domain' }, { col3: 'Expiration' }, { col4: 'Description' }],
                  blocks: [
                    {
                      title: t('usage-title'),
                      description: t('usage-description'),
                    },
                    {
                      title: t('necessary-title'),
                      description: t('necessary-description'),
                      toggle: {
                        value: 'necessary',
                        enabled: true,
                        readonly: true, // cookie categories with readonly=true are all treated as "necessary cookies"
                      },
                    },
                    {
                      title: t('analytics-title'),
                      description: t('analytics-description'),
                      toggle: {
                        value: 'analytics', // there are no default categories => you specify them
                        enabled: false,
                        readonly: false,
                      },
                      cookie_table: [
                        {
                          col1: '^_ga',
                          col2: 'google.com',
                          col3: '2 years',
                          col4: 'description ...',
                          is_regex: true,
                        },
                      ],
                    },
                    {
                      title: t('more-info-title'),
                      description: t('more-info-description'),
                    },
                  ],
                },
              },
            },
            current_lang: lang,
          });
        });
    }
  }
}
